import { createMemo, JSX, Show } from 'solid-js';
import { useFaqWidget } from '../../../providers/context';
import { TextField, TextFieldDescription, TextFieldInput } from '~/components/ui/text-field';
import { cn } from '~/util/utils';

interface SearchBarProps extends Pick<JSX.HTMLAttributes<HTMLDivElement>, "class"> {

}

export function SearchBar(props: SearchBarProps) {

	const {
		search,
		setSearch,
		searchedArticles
	} = useFaqWidget();

	const searchedAmount = createMemo<number>(() => {
		return searchedArticles()
			.flatMap(x => x.articles)
			.length;
	});

	return (
		<TextField 
			class="flex-1 lg:px-0 lg:mb-4"
			value={search()}
			onChange={setSearch}
		>
			<TextFieldInput
				class={cn("outline-none mb-1", props.class)}
				type='text'
				placeholder='Zoek naar een vraag...'
			/>
			<Show when={search()}>
				<TextFieldDescription class="mt-2">
					Zoekresultaten - {searchedAmount()} gevonden
				</TextFieldDescription>
			</Show>
		</TextField>
	);
}